import { render, staticRenderFns } from "./BaseLinkButton.vue?vue&type=template&id=0d45bcf0&scoped=true"
import script from "./BaseLinkButton.vue?vue&type=script&lang=js"
export * from "./BaseLinkButton.vue?vue&type=script&lang=js"
import style0 from "./BaseLinkButton.vue?vue&type=style&index=0&id=0d45bcf0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45bcf0",
  null
  
)

export default component.exports